export const FETCH_USER_ISSUES_LOGS = 'FETCH_USER_ISSUES_LOGS';
export const FETCH_USER_ISSUES_LOGS_SUCCESS = 'FETCH_USER_ISSUES_LOGS_SUCCESS';
export const FETCH_USER_ISSUES_LOGS_ERROR = 'FETCH_USER_ISSUES_LOGS_ERROR';

export const FETCH_USER_LATEST_ISSUES = 'FETCH_USER_LATEST_ISSUES';
export const FETCH_USER_LATEST_ISSUES_SUCCESS = 'FETCH_USER_LATEST_ISSUES_SUCCESS';
export const FETCH_USER_LATEST_ISSUES_ERROR = 'FETCH_USER_LATEST_ISSUES_ERROR';

export const CHANGE_ISSUE_STATUS = 'CHANGE_ISSUE_STATUS';
export const CHANGE_ISSUE_STATUS_SUCCESS = 'CHANGE_ISSUE_STATUS_SUCCESS';
export const CHANGE_ISSUE_STATUS_ERROR = 'CHANGE_ISSUE_STATUS_ERROR';
